import { render, staticRenderFns } from "./customer-sales-representative.vue?vue&type=template&id=a516ac8c"
import script from "./customer-sales-representative.vue?vue&type=script&lang=js"
export * from "./customer-sales-representative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports